import { Outlet, createRootRouteWithContext, Link } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { ArrowUpRight } from "lucide-react";
import { Container } from "@/components/container";
import { Button } from "@/components/ui/button";

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({ component: RootComponent });

function RootComponent() {
  return (
    <div className="flex min-h-screen flex-col text-foreground">
      <header className="border-b bg-background">
        <Container width="lg" className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 font-semibold tracking-tight">
            <span className="inline-block h-2.5 w-2.5 rounded-full bg-primary" />
            <span>Bytebeam</span>
            <span className="font-normal text-muted-foreground">· Careers</span>
          </Link>
          <Button variant="ghost" size="sm" asChild>
            <a href="https://bytebeam.io" className="shrink-0">
              bytebeam.io
              <ArrowUpRight aria-hidden="true" />
            </a>
          </Button>
        </Container>
      </header>
      <main className="flex-1 pb-24"><Outlet /></main>
      <footer className="fixed inset-x-0 bottom-0 z-30 border-t bg-background/95 backdrop-blur">
        <Container width="lg" className="flex flex-col gap-2 py-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Bytebeam</span>
          <span>We prioritize and respond to all submissions that show clear intent and relevant work.</span>
        </Container>
      </footer>
    </div>
  );
}
